// extracted by mini-css-extract-plugin
export default {"container":"TabLink_container__Jh+5R","active":"TabLink_active__BZ5IG","content":"TabLink_content__D0YWd"};